import { ICurrentUserResponse } from '@kcftech/prometheus-client';
import { User } from 'configcat-react';

type BuildConfigCatUserOptions = Readonly<{
    user: ICurrentUserResponse;
    corporationId?: string;
    locationId?: string;
}>;

/**
 * Builds a ConfigCat `User` from the app's current user identity and
 * optional corporation/location context. The returned object is passed to
 * flag evaluations so that they include targeting attributes like role,
 * corporation, and location.
 */
export function buildConfigCatUser({
    user,
    corporationId,
    locationId,
}: BuildConfigCatUserOptions): User {
    return new User(user.Id, user.Email, undefined, {
        role: user.ApplicationRole,
        corporationIds: user.Corporations.map((c) => c.CorporationId),
        locationIds: user.Locations.map((l) => l.LocationId),
        ...(corporationId && {
            currentCorporationId: corporationId,
        }),
        ...(locationId && {
            currentLocationId: locationId,
        }),
    });
}
